import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import * as mobx from 'mobx';
import { AssetsBiographyFormViewModel } from './assets-biography-form.viewmodel';
import DefaultButton from '../../../../global/default-button/default-button';
import { FormField } from '../../../../global/form/form-field/form-field';
import { RichTextEditor } from '../../../../global/rich-text-editor';
import { applyText, cancelText } from '../../../../../constants/common-labels.constants';

import './assets-biography-form.scss';

interface Props {
    vm: AssetsBiographyFormViewModel;
}

export const AssetsBiographyFormPresentation = observer((props: Props): JSX.Element => {
    const { vm } = props;
    const { biography, permissionToUpdate, isLoading } = vm;

    const onApply = (): void | null => {
       vm.updateBiography();
    };

    return (
        <div className='assets-download-file-form-in-popover' data-test-id='assets-biography-popup'>
            <div className='assets-download-file-form-in-popover__content'>
                <FormField
                    label={<FormattedMessage
                        id='oe.attendee.Biography'
                        description='Label text'
                        defaultMessage='Biography'
                    />}
                >
                    <RichTextEditor
                        className='m-top-0px'
                        id='template-body'
                        value={biography}
                        onChange={mobx.action((event, editor) => {
                            vm.setBiography(editor.getData());
                        })}
                        validationError={vm.getBiographyError()}
                        data-test-id='assets-biography-rich-text-editor'
                        disabled={!permissionToUpdate}
                    />
                </FormField>
            </div>
            {permissionToUpdate && <div className='oe-popup-layout__footer'>
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        text={applyText()}
                        modifier={['fat', 'confirm-safe']}
                        onClick={onApply}
                        disabled={isLoading}
                    />
                    <DefaultButton
                        modifier='cancel'
                        text={cancelText()}
                        onClick={() => vm.closeAssetsBiographyPopup()}
                    />
                </div>
            </div>}
        </div>
    );
});
